import { render, staticRenderFns } from "./ExtForm.vue?vue&type=template&id=1d2ff8e7&"
import script from "./ExtForm.vue?vue&type=script&lang=js&"
export * from "./ExtForm.vue?vue&type=script&lang=js&"
import style0 from "./ExtForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports